
/* injects from baggage-loader */

'use strict';

import IssuerOnboardingFinalizeComponent from './issuer-onboarding.finalize.component';

const IssuerOnboardingFinalizePageModule = angular.module('issuer-onboarding-finalize-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('issuer-onboarding.finalize', {
        url: '/finalize',
        title: 'Issuer Onboarding: Finalize',
        localTitle: 'Finalize Onboarding',
        component: 'issuerOnboardingFinalize',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('issuerOnboardingFinalize', new IssuerOnboardingFinalizeComponent());

export default IssuerOnboardingFinalizePageModule;
